import { render, staticRenderFns } from "./WantedPartsBanner.vue?vue&type=template&id=280e9b6c&scoped=true&"
import script from "./WantedPartsBanner.vue?vue&type=script&lang=ts&"
export * from "./WantedPartsBanner.vue?vue&type=script&lang=ts&"
import style0 from "./WantedPartsBanner.vue?vue&type=style&index=0&id=280e9b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e9b6c",
  null
  
)

export default component.exports